import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withProps, withHandlers, compose, defaultProps } from 'recompose';
import { partial } from 'lodash';
import Form from './Form';
import * as actions from './actions';
import { trimFunction } from '../../../common/trimData';
import { isBrandViewActive, getBarberUser, getShop, getShopBrandId } from '../../../auth/selectors';
import withBaseUrlByRole from '../../../common/hoc/withBaseUrlByRole';
import { t } from '../../../../modules/infra/i18n';

const mapStateToProps = state => ({
  shop: getShop(state),
  barberUser: getBarberUser(state),
  isBrandUser: isBrandViewActive(state),
  brandId: getShopBrandId(state),
});

const mapDispatchToProps = {
  onSubmit: actions.addItem,
};

export default compose(
  withRouter,
  withProps(props => ({ title: props.title || t('services:categories.form.add_title') })), // ✅ t() called at runtime
  connect(mapStateToProps, mapDispatchToProps),
  withBaseUrlByRole('/services/categories'),
  withProps(props => ({ onSubmit: partial(props.onSubmit, props.brandId) })),
  withHandlers({
    onSubmit: props => trimFunction(props.onSubmit),
  }),
)(Form);
